import React from 'react';
import { ShieldCheck, Globe2, Plane, Briefcase } from 'lucide-react';
import { SectionReveal } from '@/components/brand/SectionReveal';

// Four discreet trust signals. NO numerical statistics, percentages or
// unverified claims — wording is deliberately understated to match a private
// advisory tone (and to remain regulatorily safe).
const TRUST_ITEMS = [
    {
        id: 'established-advisory',
        label: 'Established Advisory',
        description: 'A senior, sober point of contact for complex commercial and private matters.',
        Icon: ShieldCheck,
    },
    {
        id: 'multi-sector-reach',
        label: 'Multi-Sector Reach',
        description: 'Property, commodities, banking, technology, legal and asset sourcing.',
        Icon: Globe2,
    },
    {
        id: 'cross-border-experience',
        label: 'Cross-Border Experience',
        description: 'International transactions and counterparty coordination across jurisdictions.',
        Icon: Plane,
    },
    {
        id: 'private-corporate',
        label: 'Private & Corporate Clients',
        description: 'Family offices, founders, boards and high-net-worth individuals.',
        Icon: Briefcase,
    },
];

const TrustBadge = ({ item }) => {
    const { Icon, label, description } = item;
    return (
        <div
            data-testid="trust-badge"
            className="group relative p-7 sm:p-8 border-r border-b border-white/8 last:border-r-0 hover:bg-white/[0.02] transition-colors duration-300"
        >
            <span
                className="inline-flex items-center justify-center h-11 w-11 rounded-la-sm border border-la-gold/30 bg-la-gold/[0.06] text-la-gold transition-shadow duration-300 group-hover:shadow-[0_0_24px_-6px_rgba(201,168,106,0.55)]"
                aria-hidden
            >
                <Icon className="h-[18px] w-[18px]" strokeWidth={1.5} />
            </span>
            <h3 className="mt-6 font-display font-normal text-[20px] sm:text-[22px] text-la-text leading-tight tracking-[-0.005em]">
                {label}
            </h3>
            <p className="mt-2.5 text-[13.5px] text-la-text2 leading-relaxed max-w-xs">
                {description}
            </p>
        </div>
    );
};

export const TrustBar = () => {
    return (
        <section
            id="trusted-for"
            data-testid="trust-section"
            className="relative border-t border-white/8 bg-la-canvas"
        >
            <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12 pt-20 sm:pt-24 pb-2">
                <SectionReveal>
                    <div className="text-center max-w-xl mx-auto">
                        <div className="meta-eyebrow">Trusted For</div>
                        <h2 className="mt-5 font-display font-normal text-[28px] sm:text-[34px] leading-[1.15] tracking-[-0.005em] text-la-text">
                            A discreet practice for serious decisions.
                        </h2>
                    </div>
                </SectionReveal>
            </div>
            <div className="max-w-6xl mx-auto px-5 sm:px-8 lg:px-12 pb-24">
                <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 border-t border-l border-white/8 rounded-la overflow-hidden bg-la-canvas2/30">
                    {TRUST_ITEMS.map((item) => (
                        <TrustBadge key={item.id} item={item} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustBar;
